module.exports = __webpack_public_path__ + "media/images/lb/419-5d8c4f15029f429f311afd0a7b455009.svg";